const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const base64 = require('base-64');
const { Base64 } = require('js-base64');
const apiConfig = require('../../api-config');
const SEPERATOR = require('../../utils/constants');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    'Content-Type': 'application/json',
  };
  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    /* Refer to EBANK-16282 for deatils of amended roster for initializeTx*/
    initializeTx(inputParam, metaData) {
      const url = getUrl('initializeTx');
      const inputs = inputParam.split(SEPERATOR.SEPERATOR);
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        txType: inputs[0],
        channel: inputs[1],
        deviceCode: inputs[2],
        arePortfoliosToBeFetched: inputs[3],
        businessUnitId:inputs[4],
        posId: inputs[5],
        assetId: inputs[6]
      };

      return requestHandler(merge(
        {},
        reqOpts, { url, body },
        parsedMetaData
      ));
    },

    /* Refer to EBANK-16608 for deatils of amended roster for generateTxChallenge*/
    generateTxChallenge(orderObj, inputParam, metaData) {
      const url = getUrl('generateTxChallenge');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const inputs = inputParam.split(SEPERATOR.SEPERATOR);
      const decodedOrderInputParam = JSON.parse(Base64.decode(orderObj));
      const channel = inputs[0];
      const txType = inputs[1];
      const txToken = inputs[2] ? inputs[2] : parsedMetaData.headers['Transaction-Token'];
      const language = parsedMetaData.portfolio.language;
      const body = {
        channel: channel,
        branchCode: apiConfig.branchCode,
        order: decodedOrderInputParam,
        txType: txType,
        txToken: txToken,
        language: language,
        userId: parsedMetaData.qs.userId,
      }
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    /* Refer to EBANK-16878 for deatils of amended roster for verifyChallengeResponse*/
    verifyChallengeResponse(inputParam, metaData) {
      const url = getUrl('verifyChallengeResponse');
      const reqOpts = { headers, method: 'POST', json: true };
      const parsedMetaData = parseRequestMetaData(metaData);
      const inputs = inputParam.split(SEPERATOR.SEPERATOR);

      const channel = inputs[0];
      const deviceCode = inputs[1];
      const decodedValidateMsgResponseParam = JSON.parse(Base64.decode(inputs[2]));
      const overrides = decodedValidateMsgResponseParam;
      const restrictedCountriesVersion = inputs[3];
      const tdsSignature = inputs[4].length <= 0 ? null : inputs[4];
      const txToken = inputs[5] ? inputs[5] : parsedMetaData.headers['Transaction-Token'];
      const txType = inputs[6];
      const language = parsedMetaData.portfolio.language;
      const msgAccepted = inputs[7];
      const statutoryMsgVersion = inputs[8];

      const body = {
        channel: channel,
        deviceCode: deviceCode,
        overrides: overrides,
        restrictedCountriesVersion: restrictedCountriesVersion,
        tdsSignature: tdsSignature,
        txToken: txToken,
        txType: txType,
        language: language,
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        msgAccepted: msgAccepted,
        statutoryMsgVersion:statutoryMsgVersion
      }
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    cancelTx(input, metaData) {
      const url = getUrl('cancelTx');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      let paymentDetails = input.split("#@#");
      const txToken = paymentDetails[5] ? paymentDetails[5] : parsedMetaData.headers['Transaction-Token'];
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        txType: paymentDetails[0],
        id: paymentDetails[1],
        channel: paymentDetails[2],
        deviceCode: paymentDetails[3],
        versionId: paymentDetails[4],
        standingOrder: paymentDetails[6] && paymentDetails[6],
        txToken: txToken,
        language: parsedMetaData.portfolio.language,
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    tradingCancelTx(input, metaData) {
      const url = getUrl('cancelTx');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      let tradeDetails = input.split("#@#");
      const txToken = tradeDetails[1] ? tradeDetails[1] : parsedMetaData.headers['Transaction-Token'];
      const body = {
        channel: tradeDetails[3],
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode,
        userId: parsedMetaData.qs.userId,
        deviceCode: tradeDetails[4],
        txType: tradeDetails[0],
        txToken: txToken,
        order: {
          orderId: tradeDetails[2]
        }
      }

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    fetchTx(fetchTxReq, metaData) {
      const url = getUrl('fetchTx');
      const inputs = fetchTxReq.split("#@#");
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        txType: inputs[0],
        orderId: inputs[1],
        deviceCode: inputs[2],
        channel: inputs[3],
        standingOrder: inputs[4] && inputs[4],
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        businessUnitId: inputs[6]
      };

      if (inputs.includes('trading')) {
        body.arePortfoliosToBeFetched = inputs[4];
      }

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    fetchWebTx(input, metaData) {
      const url = getUrl('fetchWebTx')
      const reqOpts = { headers, method: 'POST', json: true }
      let inputs = input.split("#@#");
      const parsedMetaData = parseRequestMetaData(metaData);
      const body = {
        userId: parsedMetaData.qs.userId,
        pfId: parsedMetaData.portfolio.pfRelId,
        type: inputs[0],
        deviceCode: inputs[1],
        channel: inputs[2],
        txType: inputs[3],
        language: parsedMetaData.portfolio.language,
        branchCode: apiConfig.branchCode
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },
    rejectTx(inputParam, metaData) {
      const url = getUrl('rejectTx')
      const reqOpts = { headers, method: 'POST', json: true }
      
      const parsedMetaData = parseRequestMetaData(metaData);
      const params = JSON.parse(Base64.decode(inputParam));

      const txToken = parsedMetaData.headers['Transaction-Token'] ? 
                      parsedMetaData.headers['Transaction-Token'] : params.txToken;
      const body = {
        txType: params.txType,
        userId: parsedMetaData.qs.userId,
        channel: params.channel,
        deviceCode: params.deviceCode || '',
        txToken: txToken,
        language: parsedMetaData.portfolio.language,
        paymentUUID: params.paymentUUID,
        rejectionReason: params.rejectionReason
      };

      
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    },

    txRefresh(metaData) {
      const url = getUrl('txRefresh');
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData);
      const txTokenBody = parsedMetaData.headers['Transaction-Token'];

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        language: parsedMetaData.portfolio.language,
        txToken: txTokenBody,
        channel: 'WEB'
      };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body },
        parsedMetaData
      ));
    }
  };
}

module.exports = apiFactory;
